var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 28L11.0001 19C11.0001 19 10.0176 16.8959 10.0176 14C10.0176 7.37258 15.8786 2 23.1085 2C27.954 2 32.1846 4.41319 34.4481 8H37.0176C41.9881 8 46.0176 12.0294 46.0176 17C46.0176 20.128 44 24 42 26.4962C40 28.9924 28 43 28 43M33.7351 22.5883L32.4496 24.1204M6.17988 39.8305L4.8943 41.3626",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.607 17.4453L13.3224 31.702L23.3075 32.2481L12 45.0001",
    stroke: "#EAAC30",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.d12b8284c02bad71848230dbdb0f7c86.svg";
export { ForwardRef as ReactComponent };